import React from 'react';
import { ExternalLink, Mouse, Eye, Settings, Code, Smartphone } from 'lucide-react';

const LayoutImplementationGuide: React.FC = () => {
  return (
    <div className="bg-gradient-to-br from-zippy-50 to-blue-50 border border-zippy-200 rounded-xl p-6 mb-8">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-8 h-8 bg-gradient-to-r from-zippy-600 to-blue-600 rounded-lg flex items-center justify-center">
          <Settings className="h-4 w-4 text-white" />
        </div>
        <h3 className="text-lg font-semibold text-slate-800">How to Access These Layout Options</h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Current Access Methods */}
        <div className="space-y-4">
          <h4 className="font-medium text-slate-700 flex items-center space-x-2">
            <Mouse className="h-4 w-4" />
            <span>Current Access Methods</span>
          </h4>
          
          <div className="space-y-3 text-sm">
            <div className="flex items-start space-x-3 p-3 bg-white rounded-lg border border-slate-200">
              <div className="w-6 h-6 bg-zippy-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-xs font-bold text-zippy-700">1</span>
              </div>
              <div>
                <span className="font-medium text-slate-800">Sidebar Navigation</span>
                <p className="text-slate-600 mt-1">Click "Layout Options" in the sidebar (marked with BETA badge)</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3 p-3 bg-white rounded-lg border border-slate-200">
              <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-xs font-bold text-blue-700">2</span>
              </div>
              <div>
                <span className="font-medium text-slate-800">Design Preview</span>
                <p className="text-slate-600 mt-1">Access through "Design Preview" for overall theme options</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3 p-3 bg-white rounded-lg border border-slate-200">
              <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-xs font-bold text-green-700">3</span>
              </div>
              <div>
                <span className="font-medium text-slate-800">Direct URL</span>
                <p className="text-slate-600 mt-1">Navigate directly to <code className="bg-slate-100 px-2 py-1 rounded text-xs">#layout-options</code></p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Features & Testing */}
        <div className="space-y-4">
          <h4 className="font-medium text-slate-700 flex items-center space-x-2">
            <Eye className="h-4 w-4" />
            <span>Testing & Features</span>
          </h4>
          
          <div className="space-y-3 text-sm">
            <div className="flex items-center space-x-3 text-slate-600">
              <Smartphone className="h-4 w-4 text-blue-500 flex-shrink-0" />
              <span>Test responsive design on different screen sizes</span>
            </div>
            
            <div className="flex items-center space-x-3 text-slate-600">
              <Code className="h-4 w-4 text-green-500 flex-shrink-0" />
              <span>Non-destructive previews - your data stays safe</span>
            </div>
            
            <div className="flex items-center space-x-3 text-slate-600">
              <ExternalLink className="h-4 w-4 text-purple-500 flex-shrink-0" />
              <span>Switch between layouts instantly</span>
            </div>
          </div>
          
          <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-xs text-yellow-800">
              <strong>Note:</strong> These are preview implementations. The actual layouts can be applied to replace the current dashboard once you choose your preferred option.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutImplementationGuide; 
